/* eslint-disable no-nested-ternary */
import PropTypes from 'prop-types';
import queryString from 'querystring';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setAturHargaFilter } from '../../../pages/SettingHarga/actions';
import { rebuildDatesFilter } from '../../../utils/builder/registrationMerchant';
import Filter from '../../elements/Filter';
import {
  fetchCities,
  fetchProvinces,
  fetchRegionals,
} from '../../layouts/PageBase/actions';
import { Fields, initialValues } from './fields';
import styles from './styles.scoped.css';
import { removeDuplicateDataAob } from '../../../utils/builder/common';
function AturHargaFilter() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { dataFilter: values } = useSelector((state) => state.prices);
  const {
    dataRegionals,
    dataProvinces,
    dataCities,
    dataDistricts,
    dataVillages,
    dataDetailUser: { regionalId, provinceId, cityId, cities },
  } = useSelector((state) => state.pageBase);
  const [selectedTemp, setSelectedTemp] = useState({
    cityId: [],
  });

  const dropdownData = {
    regional: [
      { value: '', label: 'Semua Regional' },
      ...dataRegionals.filter((item) => item.value !== ''),
    ],
    provinces: [
      { value: '', label: 'Semua Provinsi' },
      ...dataProvinces.filter((item) => item.value !== ''),
    ],
    cities: [
      { label: 'Semua Kota/Kab', value: '' },
      ...dataCities.filter((item) => item.value !== ''),
    ],
    districts: [
      { value: '', label: 'Semua Kecamatan' },
      ...dataDistricts.filter((item) => item.value !== ''),
    ],
    villages: [
      { value: '', label: 'Semua Kelurahan' },
      ...dataVillages.filter((item) => item.value !== ''),
    ],
  };

  const handleGetAdministrativeArea = (name, params) => {
    const payloadProvince = {
      regional: params?.regional ? JSON.stringify([params?.regional]) : '',
    };
    const payloadCity = {
      ...payloadProvince,
      provinceId: params?.provinceId && JSON.stringify([params?.provinceId]),
    };
    if (name === 'regional') {
      dispatch(fetchProvinces(payloadProvince));
      dispatch(fetchCities(payloadProvince));
    }
    if (name === 'provinceId') {
      dispatch(fetchCities(payloadCity));
    }
  };

  const handleSearchFilter = (query) => {
    // if(regionalId !== undefined){
    const payloadCity = {
      regional: regionalId ? JSON.stringify([regionalId]) : query?.regional,
      provinceId: query?.provinceId?.length > 4 ? query?.provinceId : '',
      search: query.target.value,
    };
    dispatch(fetchCities(payloadCity, selectedTemp.cityId));
    // }
  };

  const handleChangeValues = ({ name, value }) => {
    let filter = {};
    if (name === 'regional') {
      filter = {
        regional: value,
        provinceId: '',
        cityId: '',
      };
    } else if (name === 'provinceId') {
      filter = {
        ...values,
        regional: regionalId ? regionalId : values.regional,
        [name]: value,
        cityId: '',
      };
    } else if (name === 'cityId') {
      filter = {
        ...values,
        [name]: value,
      };
      const originDataTemp = [
        ...selectedTemp.cityId.filter((row) => value.includes(row.value)),
        ...dataCities.filter((row) => value.includes(row.value)),
      ];
      setSelectedTemp((val) => {
        return {
          ...val,
          cityId: removeDuplicateDataAob(originDataTemp, 'value'),
        };
      });
    } else {
      filter = { ...values, [name]: value };
    }
    const newQuery = queryString.stringify({
      ...filter,
      // regional: userRegion ?? '',
    });

    navigate(`?${newQuery}`);
    handleGetAdministrativeArea(name, filter);
    dispatch(setAturHargaFilter(filter));
  };

  const handleReset = () => {
    dispatch(
      setAturHargaFilter({
        ...initialValues,
        regional: regionalId,
        provinceId: provinceId,
        cityId: cityId,
      })
    );
    navigate('?');
  };

  useEffect(() => {
    if (regionalId !== undefined) {
      dispatch(fetchRegionals());
      const newQuery = rebuildDatesFilter({
        regional: regionalId,
        provinceId: provinceId,
        cityId: cities,
      });
      dispatch(setAturHargaFilter(newQuery));
      handleGetAdministrativeArea('regional', newQuery);
    }
  }, [regionalId]);

  return (
    <Filter
      className={styles.filterContainer}
      fields={Fields({
        values,
        handleChangeValues,
        handleSearchFilter,
        dropdownData,
        regionalId,
        provinceId,
        cities,
        cityId,
      })}
      handleReset={handleReset}
    />
  );
}

export default AturHargaFilter;

AturHargaFilter.propTypes = {
  type: PropTypes.string,
};
